import { useForm } from 'react-hook-form';

import { ScheduleItemFormData } from '../types';

type UseScheduleItemFormParams = {
  defaultValues?: Partial<ScheduleItemFormData>;
};

export function useScheduleItemForm({ defaultValues }: UseScheduleItemFormParams = {}) {
  return useForm<ScheduleItemFormData>({
    mode: 'all',
    defaultValues: {
      repetitionDayOfWeek: [],
      startHour: '',
      endHour: '',
      ...defaultValues,
    },
  });
}
